// Proxies exists as interface components to describe the shape of the table.
// They are merely used as a container to look at the props attached to the Proxy component
// when we loop through the collection of them inside the Table component.
export const TableDrawerColumn = (props) => props;
export const TableDrawer = (props) => props;
export const TableColumn = (props) => props;
